export const formatPrice = (price=0) => {
	if (typeof price === 'string') {
		price = Number(price);
	}
	let formattedPrice = price ? price.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0;

	return formattedPrice;
}